// extracted by mini-css-extract-plugin
export var activeDot = "_9c-c";
export var buttonContainer = "_9c-9";
export var channelButton = "_9c-a";
export var clickable = "_9c-d";
export var content = "_9c-0";
export var contentFull = "_9c-2";
export var contentThird = "_9c-1";
export var contentWrapper = "_9c-7";
export var description = "_9c-5";
export var heightShort = "_9c-f";
export var image = "_9c-3";
export var imageContainer = "_9c-4";
export var selectButton = "_9c-e";
export var spinnerContainer = "_9c-b";
export var titleContent = "_9c-8";
export var titleWrapper = "_9c-6";